<template>
    <div class="activity-section">
        <div class="head" @click="edit">
            <h6>{{ section.name }}</h6>
            <p>{{ section.description }}</p>
        </div>

        <draggable class="activities"
                   v-model="activities"
                   item-key="id"
                   group="activity-section">
            <template #item="{element, index}">
                <div :class="`aw-${element.options.width}`"
                     class="item">
                    <activity :activity="element"
                              @click="select( index )"/>
                </div>
            </template>
        </draggable>

    </div>
</template>

<script>
import draggable from "vuedraggable";
import Activity from "@/Components/LearningPath/Activity";
import API from "@/API";
import Modal from "@/Components/Common/Modal";
import utils from "@/mixins/utils";
export default {
    name: "ActivitySection",
    components: { Activity, draggable, Modal },
    props: ['path', 'stage', 'section', 'number'],
    emits: ['activities-changed', 'select-activity'],
    mixins: [utils],

    data(){
        return {
            section_activities: [],
            selected_index: -1,
        }
    },

    computed: {

        fragment_key(){
            return `stage_${this.stage}_activities_${this.section.id}`;
        },

        activity_ids(){
            return typeof this.path.fragments[ this.fragment_key ] === 'undefined' ? [] : this.path.fragments[ this.fragment_key ];
        },

        activities: {
            get(){
                return this.section_activities;
            },
            set(activities){
                this.section_activities = activities;
                this.$emit('activities-changed', activities.map(activity => activity.id));
            }
        },

        selected(){
            return this.activities[ this.selected_index ];
        }

    },


    watch: {
        activity_ids(ids){
            console.log({changed: ids});
            this.fetch( ids );
        }
    },

    methods: {

        edit(){
            this.$emit('edit-activity');
        },

        select(index){
            this.selected_index = index;
        },

        deselect(){
            this.selected_index = -1;
        },

        remove(){
            if( !confirm('Are you sure to delete this activity?') ) return;
            this.activities = this.activities.filter((a, i) => i !== this.selected_index);
            this.selected_index = -1;
        },

        async fetch(ids){
            if( !ids.length ) this.section_activities.length = 0;
            else{
                const activities = await API.activities.bulk( ids );
                this.section_activities = ids.map( id => activities.filter( activity => activity.id === id ).pop() )
            }
        }

    },


    mounted() {
        this.fetch( this.activity_ids );
    }

}
</script>

<style lang="scss" scoped>
.activities{
    display: flex;
    margin-left: -0.3rem;
    margin-right: -0.3rem;
    flex-wrap: wrap;
    align-items: stretch;

    .item{
        display: flex;
        padding: 0 0.3rem;
        margin-bottom: 0.6rem;
    }
}


.aw-1{
    @include media-breakpoint-up(lg){
        flex: 0 0 20%;
    }
}

.aw-2{
    @include media-breakpoint-up(lg){
        flex: 0 0 40%;
    }
}

.aw-3{
    @include media-breakpoint-up(lg){
        flex: 0 0 60%;
    }
}
.aw-4{
    @include media-breakpoint-up(lg){
        flex: 0 0 80%;
    }
}
.aw-5{

}

.activity-section{
    .head{
        &:hover{
            cursor: text;
            background: rgba(black, 0.05);
        }
    }
}

</style>
